// External dependencies
import { ofType } from 'redux-observable';
import { Observable, switchMap } from 'rxjs';

// Local dependencies
import { getClient } from '../../../../../clients/demirbank';
import compressedImage from '../../../../common/compressedImage';
import { cleanPayload } from '../../../../common/helpers';
import { createCategoryError, createCategorySuccess } from './actions';
import { createCategoryMutation } from './mutation';
import { CreateCategory, CreateCategoryAction, CreateCategoryActionType } from './types';

export function createCategoryEpic(action$: Observable<CreateCategoryAction>) {
  return action$.pipe(
    ofType(CreateCategoryActionType.CREATE_CATEGORY),
    switchMap((action: CreateCategory) =>
      createCategory(action).then(createCategorySuccess).catch(createCategoryError),
    ),
  );
}

async function createCategory(action: CreateCategory) {
  const graphQLClient = await getClient();

  const categoryData = { ...action.input };
  const logoFiles = categoryData.logo as unknown as FileList;

  if (!logoFiles || logoFiles.length === 0) {
    delete categoryData.logo;
  } else {
    const compressedLogo = await compressedImage(logoFiles[0]);

    categoryData.logo = { url: compressedLogo.replace(/^data:image\/[a-z]+;base64,/, '') };
  }

  if (categoryData.tags && Array.isArray(categoryData.tags)) {
    const tags = new Set(categoryData.tags.map((item) => item.value));

    categoryData.tags = Array.from(tags);
  } else {
    categoryData.tags = [];
  }

  const cleanInput = cleanPayload(categoryData);

  const {
    data: { createCategory },
  } = await graphQLClient.query({
    query: createCategoryMutation,
    variables: { input: cleanInput },
  });

  return createCategory;
}
